import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import RecipeReviewCard from "../../components/RecipeReviewCard/RecipeReviewCard";
import EditNotice from "./NoticeEditPage";
import { _callApiMessage2, _callApiMessage3 } from "GlobalFunction";
import GlobalValue from "GlobalValue";
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";
const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5
  }
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = event => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = event => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = event => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true
})(TablePaginationActions);

let counter = 0;
function createData(name, calories, fat) {
  counter += 1;
  return { id: counter, name, calories, fat };
}

const styles = theme => ({
  root: {
    width: "50%",
    minWidth: 700,
    marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 700
  },
  tableWrapper: {
    overflowX: "auto"
  },
  noticeContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "50px"
  }
});

class CustomPaginationActionsTable extends React.Component {
  state = {
    rows: [
      createData("Cupcake", 305, 3.7),
      createData("Donut", 452, 25.0),
      createData("Eclair", 262, 16.0),
      createData("Frozen yoghurt", 159, 6.0),
      createData("Gingerbread", 356, 16.0),
      createData("Honeycomb", 408, 3.2),
      createData("Ice cream sandwich", 237, 9.0),
      createData("Jelly Bean", 375, 0.0),
      createData("KitKat", 518, 26.0),
      createData("Lollipop", 392, 0.2),
      createData("Marshmallow", 318, 0),
      createData("Nougat", 360, 19.0),
      createData("Oreo", 437, 18.0)
    ].sort((a, b) => (a.calories < b.calories ? -1 : 1)),
    page: 0,
    rowsPerPage: 5,
    clickedItem: null,
    isEdit: false,
    refList: [],
    sysCompany: [],
    crudGubun: "C"
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ page: 0, rowsPerPage: event.target.value });
  };
  tableClicked = async row => {
    // console.log("row", this.getNoticeDetail(row));
    this.setState({ clickedItem: await this.getNoticeDetail(row) });
  };
  _isEdit = () => {
    this.setState({ isEdit: !this.state.isEdit, crudGubun: "C" });
  };
  getNoticeDetail = async noticeList => {
    // console.log("noticeList", noticeList);

    var parm = {
      eddatetime: noticeList.EDDATETIME,
      edmillisecond: noticeList.EDMILLISECOND,
      ejstcode: noticeList.EDSTCODE
    };
    await _callApiMessage3(
      "notice/getNoticeDetail",
      // `parm=${JSON.stringify(parm)}`

      parm
    )
      .then(responsBody => {
        // console.log("?", responsBody);
        noticeList = { ...noticeList, ...responsBody.data };
      })
      .catch(error => {
        console.log("eror", error);
      });
    return noticeList;
    // console.log("noticeList2", noticeList);
  };
  componentDidMount = async () => {
    var sysCompany = [];
    var refList = [];
    var noticeList = [];
    await _callApiMessage2("notice/getRefUser", "")
      .then(responsBody => {
        // console.log("?", responsBody);
        refList = responsBody.data;
        // this.setState({ refList: responsBody.data });
      })
      .catch(error => {
        console.log("eror", error);
      });
    await _callApiMessage2("notice/getSysCompany", "")
      .then(responsBody => {
        // console.log("?", responsBody);
        sysCompany = responsBody.data;
        // this.setState({ sysCompany: responsBody.data });
      })
      .catch(error => {
        console.log("eror", error);
      });
    let parm = {
      stcode: JSON.parse(localStorage.getItem("USERINFO")).SUSTCode
    };

    await _callApiMessage2(
      "notice/getNoticeList",
      `stcode=${JSON.parse(localStorage.getItem("USERINFO")).SUSTCode}`
    )
      .then(responsBody => {
        // console.log("??", responsBody);
        noticeList = responsBody.data;
        console.log("noticeList", noticeList);
      })
      .catch(error => {
        console.log("eror", error);
      });
    noticeList.length > 0
      ? this.setState({
          sysCompany,
          refList,
          noticeList,
          clickedItem: await this.getNoticeDetail(noticeList[0])
        })
      : this.setState({
          sysCompany,
          refList
        });
  };
  updateNotice = async row => {
    var noticedetail = await this.getNoticeDetail(row);
    this.setState({ crudGubun: "U", isEdit: true, clickedItem: noticedetail });
  };
  render() {
    const { classes } = this.props;
    const { rows, rowsPerPage, page } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    // console.log("this.state.noticeList", this.state);
    return (
      <div className={classes.noticeContainer}>
        <label style={{ fontSize: "2rem" }}>공지사항</label>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          {!this.state.isEdit ? (
            <RecipeReviewCard noticeItem={this.state.clickedItem} />
          ) : (
            <EditNotice
              refList={this.state.refList}
              sysCompany={this.state.sysCompany}
              _isEdit={this._isEdit}
              gubun={this.state.crudGubun}
              noticeItem={this.state.clickedItem}
            />
          )}
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            marginTop: "30px"
          }}
        >
          <button style={{ height: "30px" }} onClick={() => this._isEdit()}>
            {!this.state.isEdit ? "글쓰기" : "취소"}
          </button>
        </div>
        <Paper className={classes.root}>
          <div className={classes.tableWrapper}>
            <Table className={classes.table}>
              <TableBody>
                {this.state.noticeList &&
                  this.state.noticeList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow style={{ cursor: "pointer" }} key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          onClick={() => this.tableClicked(row)}
                        >
                          {row.EDTITLE}
                        </TableCell>
                        <TableCell
                          align="right"
                          onClick={() => this.tableClicked(row)}
                        >
                          {row.EDDATETIME}
                        </TableCell>
                        <TableCell align="right">
                          <button onClick={() => this.updateNotice(row)}>
                            수정
                          </button>
                          <button>삭제</button>
                        </TableCell>
                      </TableRow>
                    ))}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 48 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={3}
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActionsWrapped}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        </Paper>
      </div>
    );
  }
}

CustomPaginationActionsTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CustomPaginationActionsTable);
